import React from 'react';
import { Typography } from 'antd';
import { formatCurrency } from '../../utils/format';

const { Text } = Typography;

/**
 * Component to display content for a cancelled lot
 * @param {Object} props
 * @param {Object} props.lot - The lot object
 */
const CancelledLotContent = ({ lot }) => (
    <>
        <div style={{ 
            textAlign: 'center', 
            color: '#722ed1',
            fontWeight: 'bold',
        }} className="lot-cancelled">
            CANCELLED
        </div>
        <div style={{ textAlign: 'center', marginBottom: '8px' }} className="lot-cancelled-title">
            <Text strong style={{ color: '#722ed1', margin: '0px', fontSize: '14px', fontWeight: 'bold' }}>
                Lot #{lot.lot_number}
            </Text>
            <Text strong style={{ 
                color: '#722ed1', 
                margin: '0px', 
                display: 'block',
                fontSize: '11px',
                lineHeight: '1.2',
                maxHeight: '32px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical'
            }}>
                {lot.title || 'Untitled Lot'}
            </Text>
        </div>
        <div style={{ textAlign: 'center' }} className="lot-cancelled-price">
            <Text style={{ color: '#722ed1', fontSize: '14px', fontWeight: 'bold' }}>
                {formatCurrency(lot.current_price || lot.starting_price)}
            </Text>
            {/* {lot.reserve_price && (
                <div style={{ marginTop: '1px' }}>
                    <Text type="secondary" style={{ color: '#722ed1', fontSize: '11px' }} className="lot-cancelled-reserve">
                        Reserve: ${formatCurrency(lot.reserve_price)}
                    </Text>
                </div>
            )} */}
        </div>
        <div style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, rgba(114, 46, 209, 0.1), rgba(114, 46, 209, 0.05))',
            pointerEvents: 'none'
        }} />
    </>
);

export default CancelledLotContent;

